import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Container = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  border-left: 3px solid #ccc;
  outline: none;
  padding: 5px 10px;
  font-family: inherit;
  letter-spacing: 0.5px;
  font-size: 2rem;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.3s;

  &:focus {
    border-left: 3px solid #658354;
    border-right: 1px solid #658354;
    border-top: 1px solid #658354;
    border-bottom: 1px solid #658354;
  }

  &:focus + label,
  &:not(:placeholder-shown) + label {
    top: -18px;
    left: 0;
    font-size: 1.8rem;
    color: #658354;
  }
`;

const PlaceholderLabel = styled.label`
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 2rem;
  color: #aaa;
  transition: all 0.3s;
  pointer-events: none;
`;

const TextArea = ({ id, placeholder, name, type }) => {
  const [label, setLabel] = useState(placeholder);

  return (
    <Container>
      <StyledTextArea
        id={id}
        placeholder={label ? '' : placeholder}
        name={name}
        type={type}
        onFocus={() => setLabel('')}
        onBlur={(e) => setLabel(e.target.value ? '' : placeholder)}
      />
      <PlaceholderLabel htmlFor={id}>{placeholder}</PlaceholderLabel>
    </Container>
  );
};

TextArea.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
};

TextArea.defaultProps = {
  type: 'text',
};

export default TextArea;
